import React from "react";
import styled from "styled-components";

const ParallaxDivider = ({
  tagline,
  taglineColor,
  bg,
  trailingElementColor
}) => {
  const ParallaxDividerWrap = styled.div`
    background-image: url('${bg}');
    visibility: visible;
    animation-name: fadeIn;
    position: relative;
    z-index: 5;
  `;

  const Tagline = styled.p`
    margin: 0;
    line-height: 3em;
    color: ${taglineColor};
    text-align: center;
    font-size: 22px;
    font-family: "Proxima Nova Condensced", sans-serif;
    overflow: hidden;
    letter-spacing: 1em;
    max-width: 100%;

    &:after,
    &:before {
      content: "";
      position: absolute;
      border: 0.2em solid transparent;
      border-top-color: ${props => props.theme.colors[trailingElementColor]};
      width: 25ex;
      transform: translateX(-4.5em) translateY(-2em) rotate(54deg);
      transform-origin: 0% 0%;
      overflow: hidden;

      @media(max-width: 992px) {
        display: none;
      }
      
    }
    &:after {
      transform: translateX(-1.5em) translateY(-2em) rotate(54deg);
    }
  `;

  return (
    <ParallaxDividerWrap className={`fix-background parallax wow fadeIn`}>
      <div className="container-fluid position-relative parallaxSection_boundingBox">
        <div className="row parallaxSection">
          <Tagline className={`col-xs-12`}>{tagline}</Tagline>
        </div>
      </div>
    </ParallaxDividerWrap>
  );
};

export const FullScreenJPG = graphql`
  fragment FullScreenJPG on ImageSharp {
    resolutions(width: 1920, toFormat: JPG) {
      src
    }
  }
`;

export default ParallaxDivider;


// WEBPACK FOOTER //
// ./src/components/ParallaxDivider/index.js